export default {
  data() {
    return {
      timeout: null,
      text: ""
    };
  },

  methods: {
    debounce(text, time = 1000) {
      if (this.text == text || text == null || text.length < 3) return;
      if (this.timeout) clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.debounceCallback(text);
        this.text = text;
      }, time);
    }
  }
};



// WEBPACK FOOTER //
// ./src/mixins/debounceMixin.js